import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'antd/dist/reset.css';
import './global.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/it';
import { App } from './app/App';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1'),
  });
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('it');
dayjs.tz.setDefault('Europe/Rome');

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p style={{ padding: 24 }}>Errore imprevisto. Ricarica la pagina.</p>}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
